import { Link, useParams } from 'react-router-dom';
import { projects } from '../static/data';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import Loader from '../components/Loader';

const ProjectsDetailPage = () => {
    const { projectId } = useParams();
    const projectdata = projects[projectId - 1];

    return (
        <div className="container mt-10">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl font-bold mb-[-20px]">{projectdata?.title}</h1>

            <Splide
                options={{
                    perPage: 1,
                    heightRatio: '50vh', // Ekran yüksekliğinin yarısı kadar
                    gap: 10,
                    rewind: true,

                }}
            >
                {!projectdata?.images && (
                    <div className="h-[50vh] flex items-center justify-center">
                        <Loader />
                    </div>
                )}
                {projectdata?.images.map((img, i) => (
                    <SplideSlide key={i}>
                        <div className="flex items-center justify-center">
                            <img
                                className="w-full h-[50vh] object-cover rounded"
                                src={img}
                                alt=""
                            />
                        </div>
                    </SplideSlide>
                ))}
            </Splide>

            <div className="bg-white pb-6 pl-6 pr-6 rounded-md shadow-md">
                <p className="text-gray-700 mt-1 mb-3" dangerouslySetInnerHTML={{ __html: projectdata?.description }} />
            </div>
        </div>
    );
};

export default ProjectsDetailPage;
